import { useState } from "react";

interface Props {
  handleAddScore: (scoreToAdd: number, isChecked: boolean) => void;
  answer: string;
  index: string;
  isValide: boolean;
  value: boolean;
}

const CheckBox: React.FC<Props> = ({
  handleAddScore,
  answer,
  index,
  isValide,
  value,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(value);

  const handleChechBoxChange = () => {
    handleAddScore(isValide === !isChecked ? 1 : -1, !isChecked);
    setIsChecked((old) => !old);
  };
  return (
    <div
      style={{
        display: "flex",
        gap: 10,
      }}
    >
      <input
        checked={isChecked ?? false}
        onChange={handleChechBoxChange}
        type="checkbox"
        id={index}
        style={{}}
        name="horns"
      />
      <label
        htmlFor={index}
        style={{
          color: "black",
          width: "100%",
          borderBottom: "1px solid lightgrey",
          cursor: "pointer",
          padding: 15,
        }}
      >
        {answer}
      </label>
    </div>
  );
};

export default CheckBox;
